import React, { forwardRef, useMemo } from "react";

const Select = forwardRef((props, ref) => {
  const {
    options,
    value,
    onChange,
    placeholder,
    name,
    onBlur,
  } = props;
  const text = useMemo(() => {
    const valueOption = options.find((option) => option.value === value);

    return valueOption?.label || placeholder || "";
  }, [value, options, placeholder]);

  return (
    <div className="w-full relative custom-select-component">
      <select
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        className="absolute left-0 top-0 opacity-0 w-full h-full z-1"
        placeholder={placeholder}
        value={value}
      >
        {options.map((option, idx) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button type="button"
      >
        <span className={!value ? "placeholder" : ""}>{text}</span>
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
          <path
            d="M5 9.5L12 16.5L19 9.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
});

Select.displayName = "Select";

export default Select;
